module.exports = __webpack_public_path__ + "img/arwen.b2ec292b.jpg";